module.exports = __webpack_public_path__ + "assets/images/chat-icon.aa31b51ddf1a4496c1908d715f11d7be.svg";